import { useTranslation } from 'react-i18next'

import { IACL, OrgMemberRole } from '@makyoapp/makyo-sdk/models/ACL'
import { Admin16, Customer16, Shield16, User16, WalletAlt16 } from '@makyoapp/makyo-icon/icon'
import { Checkbox, CheckboxTable, CTRowTh, JustifyVariant } from '@makyoapp/makyo-ui'

import useACLOrg from './hooks/useACLOrg'

/**
 * Org detail page for Org ACL View Tab
 *
 * the user IACL rules settings
 * @param rules
 *
 * set is saved callback
 * to show or hide saved message
 * @param setIsSaved
 * @constructor
 */
export default function OrgDetailACLForOrg({
  rules,
  setIsSaved,
}: {
  rules: IACL
  setIsSaved: (saved: boolean) => void
}) {
  const { t } = useTranslation()
  const { values, canEditACL, handleCheck } = useACLOrg(rules, setIsSaved)

  return (
    <CheckboxTable
      id='org-detail-acl'
      keys={[
        {
          id: OrgMemberRole.Admin,
          icon: <Admin16 />,
          label: t('Admin'),
        },
        {
          id: OrgMemberRole.Manager,
          icon: <User16 />,
          label: t('Manager'),
        },
        {
          id: OrgMemberRole.Accountant,
          icon: <WalletAlt16 />,
          label: t('Accountant'),
        },
        {
          id: OrgMemberRole.Member,
          icon: <Customer16 />,
          label: t('Member'),
        },
      ]}
      itemSpan={(span) => span + 1}
      beforeRowTh={<CTRowTh label={t('Owner')} icon={<Shield16 />} />}
      afterCellTitle={
        <td>
          <Checkbox checked disabled justify={JustifyVariant.Center} />
        </td>
      }
      values={values}
      renderLabel={(label) => {
        return t(label)
      }}
      canEdit={canEditACL}
      onClick={handleCheck}
    />
  )
}
